export default (list, search, key='name') => {
  return list.filter((item) => {
    return item[key].toUpperCase().includes(search.toUpperCase());
  }).sort((a,b) => {
    return a[key] > b[key] ? 1 : -1;
  });
};
